import {
  FIELD_CATEGORIES,
  FieldCategoryType,
  FieldType,
  InputFieldType,
  InputFieldTypes,
  UIFieldType,
  UIFieldTypes,
} from '@/model/types/field';
export const isFieldInputType = <T extends {type: FieldType}>(field: T): field is Extract<T, {type: InputFieldType}> =>
  ([...InputFieldTypes] as string[]).includes(field.type);

export const isFieldUIType = <T extends {type: FieldType}>(field: T): field is Extract<T, {type: UIFieldType}> =>
  ([...UIFieldTypes] as string[]).includes(field.type);

export const getFieldCategoryType = <T extends {type: FieldType}>(field: T): FieldCategoryType => {
  if (isFieldInputType(field)) return FIELD_CATEGORIES.INPUT;
  if (isFieldUIType(field)) return FIELD_CATEGORIES.UI;
  throw new Error(`Unknown field type: ${field.type}`);
};
